import {ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs';
import {Injectable} from '@angular/core';
import {Store} from '@ngrx/store';
import {map} from 'rxjs/operators';

@Injectable({providedIn: 'root'})
export class AuthGuard implements CanActivate {
  readonly loggedIn$: Observable<boolean>;
  constructor(private store: Store<any>) {
    this.loggedIn$ = this.store.select(anState => anState.auth.user).pipe(map((user) => user != null));
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean > {
    return this.loggedIn$;
  }

}
